import { useEffect, useRef, useState } from "react";
import { Button, Card, CardBody, CardTitle } from "reactstrap";
import { Action } from "../../../types/reducer-action";
import { IValueInfoInput } from "../../../types/valuelist";
import AccordionContainer from "../../common/accordion-container";
import AutoFocusDiv from "../../common/auto-focus-div";
import BusyButton from "../../common/busy-button";
import ChangeAlert, { ChangeAlertRef } from "../../common/change-alert";
import { DataEntryEvent } from "../../common/data-entry-reducer";
import { RefreshIcon, SaveIcon } from "../../common/icons";
import useValueListApi from "./useValueListApi";
import ValueEditForm from "./value-edit-form";
import { useValueListDispatch, useValueListState } from "./value-list-manager-context";

const ValueDetailsPane = () => {
  const { dataSet, selectedDataId, dataDetails } = useValueListState();

  const dispatch = useValueListDispatch();

  const { updateValueInfo, busy } = useValueListApi();

  const [dirty, setDirty] = useState(false);

  const changeAlertRef = useRef<ChangeAlertRef>(null);

  useEffect(() => {
    if (!selectedDataId) return;

    const valueInfo = dataSet?.find(item => item.id === selectedDataId);

    dispatch(new Action(DataEntryEvent.SetDataDetails, {
      ...valueInfo,
      parentId: valueInfo?.parent?.id
    }));
  }, [dataSet, selectedDataId]);

  const handleSubmit = (input: IValueInfoInput) => dataDetails?.id &&
    updateValueInfo(dataDetails.id, input)
      .then(ok => changeAlertRef.current?.complete(ok));

  if (!dataDetails) {
    return <></>;
  }

  return (
    <Card>
      <CardBody>
        <CardTitle>
          <AutoFocusDiv trigger={dataDetails}>
            Value: {dataDetails.label} ({dataDetails.code})
          </AutoFocusDiv>
        </CardTitle>

        <ChangeAlert isOpen={dirty}
          itemName={`value '${dataDetails.code}'`}
          onDiscard={() => setDirty(false)}
          ref={changeAlertRef} />

        <div className="oms-row">
          <BusyButton type="submit" form="value_update_form"
            aria-label="Save" color="primary"
            disabled={!dirty}
            value="Save" busy={busy}>
            <SaveIcon />
          </BusyButton>

          <Button type="reset" form="value_update_form"
            aria-label="Reset" color="secondary"
            disabled={busy} >
            <RefreshIcon /> Reset
          </Button>
        </div>

        <AccordionContainer title="Value Information">
          <ValueEditForm id="value_update_form" wide
            onChange={setDirty} onSubmit={handleSubmit} />
        </AccordionContainer>
      </CardBody>
    </Card>
  );
};

export default ValueDetailsPane;
